export const joinArgs = (...args: (string | undefined)[]): string => args.filter(a => a && a.trim() !== '').join(' ');

export const uniqueStringFilter = (val: string | null, idx: number, self: (string | null)[]): boolean => self.indexOf(val) === idx;
